import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Indictment = types.compose(
  BaseEntity,
  types.model('Indictment', {
    indictmentId: types.identifierNumber,
    planningId: types.integer,
    description: types.maybe(types.string),
  }),
);
